// extracted by mini-css-extract-plugin
export default {"button":"WijSu6lGSW8KWQmo0xvz"};